import { axiosInstance } from '@/modules/shared/lib/axios';
import { ViolationConfigurationPayload } from './types';

type Props = {
  companyId: string
  payload: ViolationConfigurationPayload
}

type UpdateResponse = {
  success: boolean
  data?: {
    message?: string
  }
}

export function updateViolationsConfiguration({ companyId, payload }: Props) {
  return axiosInstance.post<UpdateResponse>(`/api/${companyId}/configuration/saveViolationsConfiguration`, payload);
}
